<template>
  <MainContainer />
</template>
<script>
import { mapActions } from "vuex";
import { MainContainer } from "./Containers/exporter.js";

export default {
  name: "dashboard-default",
  mounted() {
    this.setAllProjects(this.$store.state);
    window.document.title = "Evolution";
  },
  components: {
    MainContainer,
  },
  methods: mapActions(["setAllProjects"]),
};
</script>
